import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import Breadcrumbs from "../common/breadcrumbs";
import { Link, useParams } from "react-router-dom";
import PickLocationSelect from "../common/pickLocationSelect";
import { calculateHourDifference, calculatePackageAmount, checkLoggedIn, CurrencySymbol, defaultDropOffDate, defaultDropOffTime, defaultPickUpDate, defaultPickUpTime, DetailsCarData, fetchUserData, formatDateVerbose, formatTimeVerbose, ListMasterData, number_format, S3CDNURL, setBodyStyle } from "../../functionsMaster";
import CarPackagesSelect from "../common/carPackagesSelect";
import Login from "../authentication/login";
import RazorpayButton from "../common/paymentButton";

const BookingCheckout = () => {
  const [bookingID, setBookingID] = useState('');
  const [message, setMessage] = useState({ status: 0, value: '' });
  const { carSlug } = useParams(); // its a car slug
  const [step, setStep] = useState(1);

  // for the Booking Creation will be here
  const [paymentForm, setpaymentForm] = useState('');

  async function confirmPayment(value = { bookingID: 0 }) {
    console.log(value);
    if (value && value.bookingID) {
        setStep(4);
        setBodyStyle({ overflow: "auto" });
        setBookingID(value.bookingID);
        window.scrollTo(0, 0); // Scroll to top on route change
      } else {
        setMessage({ ...message, status: 0, value: value.message });
      }
  }
  const makeBooking = async () => {
    try {
      const temp = {
        address: userData.address ? userData.address : '', 
        dob: userData.dob ? userData.dob : '',
        email: userData.email ? userData.email : '',
        mobile: userData.mobile ? userData.mobile : '',
        emailAlt: userData.emailAlt ? userData.emailAlt : '',
        mobileAlt: userData.mobileAlt ? userData.mobileAlt : '',
        name: userData.name ? userData.name : '',
        remark: userData.remark ? userData.remark : '',
        persons: userData.persons ? userData.persons : '',
      }

      const rentalCharge = calculatePackageAmount(
                            selectedPackageData,
                            calculateHourDifference(
                              formData.pickUpDate,
                              formData.pickUpTime,
                              formData.dropOffDate,
                              formData.dropOffTime
                            ),
                            false,
                          );
      const fields = {
          ...formData,
          action: formData.actioon + 1,
          userID: userData._id,
          total: Number(rentalCharge) + Number(formData.rentDepotit) + Number(formData.pickCharge),
          rentalCharge,
        }
console.log(fields);
      const tempForm = <RazorpayButton
                          formData={fields}
                          userData={temp}
                          confirmPayment={confirmPayment}
                        />
                     setFormData({ ...formData, makingPay: true })  
            setpaymentForm(tempForm);
      
    } catch(e) {
      console.log({ status: 0, message: e.message });
    }
    console.log("tempcarsPackages");
  };
  // for the Booking Creation will be here

  function changeFunctionPickCharge() {
    setFormData({
      ...formData,
      pickCharge: Number(localStorage.getItem('pickCharge')) > 0 ? Number(localStorage.getItem('pickCharge')) : 0
    });
  }
  const [carData, setcarData] = useState({
    pricing: [],
    localDriveRate: 5000,
    outstaionDriveRate: 7000,
  });
  const [carsPackages, setCarsPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(localStorage.getItem('pkgID') ? localStorage.getItem('pkgID') : '');
  const [selectedPackageData, setSelectedPackageData] = useState({});

  let rentDepotit = localStorage.getItem('rentDepotit');
  if (!rentDepotit) {
    rentDepotit = '5000';
  }

  const [formData, setFormData] = useState({
    action: 1,
    makingPay: false,
    carSlug,
    carID: localStorage.getItem('carID'),
    pickUpDate: defaultPickUpDate(),
    pickUpTime: defaultPickUpTime(),
    dropOffDate: defaultDropOffDate(),
    dropOffTime: defaultDropOffTime(),
    rentDepotit: Number(rentDepotit),
    pickCharge: Number(localStorage.getItem('pickCharge')),
    driveType: 'local',
  });

  const [loggedIn, setLoggedIn] = useState({ status: 0, message: "" });

  const checkIfLoggedInAgain = async () => {
    try {
      const tempcarsPackages = await checkLoggedIn();
      setLoggedIn(tempcarsPackages);
    } catch(e) {
      setLoggedIn({ status: 0, message: e.message });
    }
  };

  const [userData, setUserData] = useState({
    address: '',
    dob: '',
    email: '',
    mobile: '',
    emailAlt: '',
    mobileAlt: '',
    name: '',
    remark: '',
    persons: '',
  });

  useEffect(() => {
    const fetchData = async (slug = "") => {
      try {
        const tempcarsPackages = await ListMasterData('carsPackages', { status: 1 });
        setCarsPackages(tempcarsPackages.data && tempcarsPackages.data.length > 0 ? tempcarsPackages.data : []);

        const userTemp = await fetchUserData({ slug });
        if (userTemp.status === 1) {
          setUserData(userTemp.data);
        } else {
          setUserData({});
          setLoggedIn({ ...loggedIn, status: 0 });
        }

        const temp = await DetailsCarData({ slug });
        if (temp?.data?.length > 0) {
          setcarData(temp.data[0]);
          localStorage.setItem('forMessage', `I need ${temp.data[0].name} for Self Drive Car Rental. I need car from `);
          let pkgID = localStorage.getItem('pkgID');
          if (!pkgID && temp.data[0].pricing && temp.data[0].pricing.length > 1) {
            pkgID = temp.data[0].pricing[1].pkgID;
            localStorage.setItem('pkgID', pkgID);
            setSelectedPackage(pkgID);
          }
          const result = temp.data[0].pricing.find((item) => item.pkgID === pkgID);
          setSelectedPackageData(result);
        } else {
          // window.location.href = "/";
        }
      } catch (error) {
        alert(error.message);
        console.log(error);
        //  window.location.href = "/";
      }
    };
    if (carSlug) {
      fetchData(carSlug);
    }
    localStorage.setItem('redURLLogged', `/checkout/${carSlug}`);
  }, [carSlug]);

  useEffect(() => {
    const checkIfLoggedIn = async () => {
      try {
        const tempcarsPackages = await checkLoggedIn();
        setLoggedIn(tempcarsPackages);
      } catch(e) {
        setLoggedIn({ status: 0, message: e.message });
      }
    };
    checkIfLoggedIn();
  }, [carSlug]);


  if (Number(loggedIn.status) === 0) {
    return (
      <div>
        <Login
          checkIfLoggedIn={checkIfLoggedInAgain}
          message={`Please Login to continue Booking the Car (<a href="/listings/car/${carSlug}">${carData.name}</a>).`}
        />
      </div>
    ) 
  }

  return (
    <div>
      <Breadcrumbs title="Checkout" subtitle="Checkout" />
      <div className="booking-new-module">
        <div className="container">
          <div className="booking-wizard-head">
            <div className="row align-items-center">
              <div className="col-xl-4 col-lg-3">
                <div className="booking-head-title">
                  <h4>Reserve Your Car</h4>
                  <p>Complete the following steps</p>
                </div>
              </div>
              <div className="col-xl-8 col-lg-9">
                <div className="booking-wizard-lists">
                  <ul>
                    <li className={step === 1 ? "active" : ""}>
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/booking-head-icon-01.svg"
                          alt="Booking Icon"
                        />
                      </span>
                      <h6>Location &amp; Time</h6>
                    </li>
                    <li className={step === 2 ? "active" : ""}>
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/booking-head-icon-03.svg"
                          alt="Booking Icon"
                        />
                      </span>
                      <h6>Detail</h6>
                    </li>
                    <li className={step === 3 ? "active" : ""}>
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/booking-head-icon-04.svg"
                          alt="Booking Icon"
                        />
                      </span>
                      <h6>Checkout</h6>
                    </li>
                    <li className={step === 4 ? "active" : ""}>
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/booking-head-icon-05.svg"
                          alt="Booking Icon"
                        />
                      </span>
                      <h6>Booking Confirmed</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="booking-detail-info">
            <div className="row">

              <div className="col-lg-8">

                {/* {console.log(selectedPackage)} */}

              <div className={`booking-information-main ${step === 4 ? '' : 'd-none'}`}>



<div className="booking-information-card">
                      <div className="booking-info-head justify-content-between">
                        <div className="d-flex align-items-center">
                          <span>
                            <i className="fa text-white fa-check" />
                          </span>
                          <h5>Billing Created</h5>
                        </div>
                      </div>
                      <div className="booking-info-body">
                          <p>Your Booking ID generated is {bookingID}</p>

                          <div className="m-3"></div>
                          
                            <Link
                              to="/user/user-dashboard"
                              onClick={() => {
                                localStorage.setItem('userMenu', 'settings');
                              }}
                              className="btn btn-warning"
                            >
                              Upload Documents
                            </Link>
                            &nbsp;&nbsp;&nbsp;
                            <Link to="/user/user-dashboard" className="btn btn-info">
                              My Dashboard
                            </Link>

                      </div>
                    </div>




              </div>


                <div className={`booking-information-main ${step === 2 ? '' : 'd-none'}`}>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      makeBooking();
                    }}
                  >
                    <div className="booking-information-card">
                      <div className="booking-info-head justify-content-between">
                        <div className="d-flex align-items-center">
                          <span>
                            <i className="bx bx-add-to-queue" />
                          </span>
                          <h5>Billing Info</h5>
                          <h5>&nbsp;&nbsp;&nbsp;</h5>
                          <div>
                            <small>
                              <i className="fa fa-envelope"></i>
                              &nbsp;{userData.email}
                              &nbsp;&nbsp;
                              <i className="fa fa-mobile"></i>
                              &nbsp;{userData.mobile}
                            </small>
                          </div>
                          
                        </div>
                      </div>
                      <div className="booking-info-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="form-label">
                                Full Name{" "} <small>(as per Driving Licence)</small>
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                required
                                type="text"
                                value={userData.name}
                                onChange={(e) => {
                                  setUserData({ ...userData, name: e.target.value });
                                }}
                                name="name"
                                className="form-control"
                                placeholder="Enter Name as per Driving Licence"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="form-label">
                                No of Persons in Trip{" "}
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="number"
                                min={1}
                                className="form-control"
                                value={userData.persons}
                                onChange={(e) => {
                                  setUserData({ ...userData, persons: e.target.value });
                                }}
                                placeholder="No of Persons in Trip"
                              />
                            </div>
                          </div>
                          
                          <div className="col-md-12">
                            <div className="input-block">
                              <label className="form-label">
                                Address{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                                value={userData.address}
                                onChange={(e) => {
                                  setUserData({ ...userData, address: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="form-label">
                                Alternative Email{" "}
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Enter Email"
                                value={userData.emailAlt}
                                onChange={(e) => {
                                  setUserData({ ...userData, emailAlt: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="form-label">
                                Alternative Mobile{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Phone Number"
                                value={userData.mobileAlt}
                                onChange={(e) => {
                                  setUserData({ ...userData, mobileAlt: e.target.value });
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="input-block">
                              <label className="form-label">
                                Any Remark
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Enter Additional Information"
                                rows={5}
                                defaultValue={""}
                                value={userData.remark}
                                onChange={(e) => {
                                  setUserData({ ...userData, remark: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          
                          <div className="col-md-12">
                            <div className="input-block m-0">
                              <label className="custom_check d-inline-flex location-check m-0">
                                <span>
                                  I have Read and Accept 
                                </span>{" "}
                                <span className="text-danger"> *</span>
                                <input type="checkbox" name="remeber" />
                                <span className="checkmark" />
                              </label>
                              <Link target="_BLANK" to="/pages/terms-condition">
                                Terms &amp; Conditions
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="booking-info-btns d-flex justify-content-end">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setStep(1);
                        }}
                        className="btn btn-secondary"
                      >
                        Back
                      </Link>
                      {formData.makingPay && (
                        <>{paymentForm}</>  
                      )}
                      {message.value !== "" && (
                        <div className="alert alert-danger">{message.value}</div>
                      )}
                      <button
                        // onClick={navigatePath}
                        className="btn btn-primary continue-book-btn"
                        type="submit"
                      >
                        Confirm &amp; Pay Now
                      </button>
                      {/* <RazorpayButton /> */}
                    </div>
                  </form>
                </div>

                <div className={`booking-information-main ${step === 1 ? '' : 'd-none'}`}>
                  <form
                    method="post"
                    onSubmit={(e) => {
                      e.preventDefault();
                      setStep(2);
                      setFormData({ ...formData, s: 1 });
                      window.scrollTo(0, 0); // Scroll to top 
                    }}
                  >
                    <div className="booking-information-card delivery-location">
                      <div className="booking-info-head">
                        <span>
                          <i className="bx bxs-car-garage" />
                        </span>
                        <h5>Location</h5>
                      </div>
                      <div className="booking-info-body">
                        <div className="form-custom">
                          <label className="form-label">
                            Pickup Location*
                          </label>
                          <div className="d-flex align-items-center">
                            <PickLocationSelect
                              changeFunction={changeFunctionPickCharge}
                              requiredValue={true}
                            />
                          </div>
                        </div>

                        <div className="form-custom">
                          <label className="form-label">
                            Where are you planning to drive?
                          </label>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="input-block m-0">
                                <label className="custom_check d-inline-flex location-check">
                                  <span>Just around the city</span>
                                  <input
                                    required
                                    type="radio"
                                    name="driveType"
                                    value="local"
                                    checked={formData.driveType === "local"}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        const t = carData.localDriveRate ? carData.localDriveRate : 5000;
                                        localStorage.setItem('rentDepotit', t);
                                        setFormData({ ...formData, rentDepotit: t, driveType: 'local' });
                                      }
                                    }}
                                  />
                                  <span className="checkmark" />
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="input-block m-0">
                                <label className="custom_check d-inline-flex location-check">
                                  <span>Going out of town</span>
                                  <input
                                    required
                                    type="radio"
                                    value="outstaion"
                                    name="driveType"
                                    checked={formData.driveType === "outstaion"}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        const t = carData.outstaionDriveRate ? carData.outstaionDriveRate : 7000;
                                        localStorage.setItem('rentDepotit', t);
                                        setFormData({ ...formData, rentDepotit: t, driveType: 'outstaion' });
                                      }
                                    }}
                                  />
                                  <span className="checkmark" />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="booking-information-card delivery-location">
                      <div className="booking-info-head">
                        <span>
                          <i className="bx bxs-car-garage" />
                        </span>
                        <h5>Packages</h5>
                      </div>
                      <div className="booking-info-body">
                        {carData && carData?.pricing && <CarPackagesSelect
                          carPackages={carsPackages}
                          carPackagPricing={carData?.pricing}
                          selectedPackage={selectedPackage}
                          setSelectedPackage={setSelectedPackage}
                          setSelectedPackageData={setSelectedPackageData}
                        />}
                      </div>
                    </div>
                    <div className="booking-info-btns d-flex justify-content-end">
                      <Link
                        to={`/listings/car/${carSlug}`}
                        className="btn btn-secondary"
                      >
                        Back to Car details
                      </Link>
                      <button
                        className="btn btn-primary continue-book-btn"
                        type="submit"
                        onClick={async() => {
                          try {
                            const userTemp = await fetchUserData({ carSlug });
                              if (userTemp.status === 1) {
                                setUserData({ ...userData, ...userTemp.data });
                              } else {
                                setUserData({});
                                setLoggedIn({ ...loggedIn, status: 0 });
                              }
                          } catch(e) {
                            setUserData({});
                            setLoggedIn({ ...loggedIn, status: 0 });
                          }
                        }}
                      >
                        Continue Booking
                      </button>
                    </div>
                  </form>
                </div>

              </div>
              <div className="col-lg-4 theiaStickySidebar">
                <div className="stickybar">
                  <div className="booking-sidebar">
                    <div className="booking-sidebar-card">
                      <div className="accordion-item border-0 mb-4">
                        <div className="accordion-header">
                          <div
                            className="accordion-button collapsed"
                            role="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordion_collapse_one"
                            aria-expanded="true"
                          >
                            <div className="booking-sidebar-head">
                              <h5>
                                Booking Details
                                <i className="fas fa-chevron-down" />
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div id="accordion_collapse_one" className="accordion-collapse collapse show">
                          <div className="booking-sidebar-body">
                            <div className="booking-car-detail p-0">
                              <span className="car-img">
                                <img
                                  src={`${S3CDNURL}${carData.image}`}
                                  alt={carData.name}
                                  style={{ maxWidth: '100%' }}
                                  className="img-fluid"
                                />
                              </span>
                              <div className="care-more-info">
                                <h5>{carData.name}</h5>
                                <div className="mt-2">
                                  <b>Pickup Date:</b>
                                  <p className="mb-1 text-success">{formatDateVerbose(formData.pickUpDate)}</p>
                                </div>
                                <p className="mb-1 mt-2">
                                  <b>Pickup Time:&nbsp;</b>
                                  <span className="text-success">
                                    {formatTimeVerbose(formData.pickUpTime)}
                                  </span>
                                </p>
                                <Link to={`/listings/car/${carSlug}`}>
                                  View Car Details
                                </Link>
                              </div>
                            </div>
                            <div className="booking-vehicle-rates">
                              <ul>
                                <li>
                                  <div className="rental-charge">
                                    <h6>Return Date</h6>
                                    <span className="text-warning">
                                      {formatDateVerbose(formData.dropOffDate)}
                                    </span>
                                  </div>
                                  <div className="rental-charge">
                                    <h6>Return Time</h6>
                                    <span className="text-danger">
                                      {formatTimeVerbose(formData.dropOffTime)}
                                    </span>
                                  </div>
                                </li>
                              </ul>
                            </div>


                            <div className="booking-vehicle-rates">
                              <ul>
                                <li>
                                  <div className="rental-charge">
                                    <h6>
                                      Rental Charges
                                      {/* <span> (1 day )</span> */}
                                    </h6>
                                    <span className="text-info">
                                      (This does not include fuel)
                                    </span>
                                  </div>
                                  <h5>
                                    {CurrencySymbol}
                                    &nbsp;
                                    {calculatePackageAmount(
                                      selectedPackageData,
                                      calculateHourDifference(
                                        formData.pickUpDate,
                                        formData.pickUpTime,
                                        formData.dropOffDate,
                                        formData.dropOffTime
                                      ),
                                      true,
                                    )}
                                  </h5>
                                </li>
                                {formData.pickCharge && Number(formData.pickCharge) > 0 ? (
                                  <li>
                                    <h6>Pick/ Drop Charges</h6>
                                    <h5>
                                      {CurrencySymbol}
                                      &nbsp;
                                      {number_format(formData.pickCharge, 0, '.', ',')}
                                    </h5>
                                  </li>
                                ) : ""}

                                <li>
                                  <h6 className="text-success"><b>Refundable Deposit</b></h6>
                                  <h5>
                                    {CurrencySymbol}
                                    &nbsp;
                                    {number_format(formData.rentDepotit, 0, '.', ',')}
                                  </h5>
                                </li>
                                {/* <li className="total-rate">
                                <h6>Total</h6>
                                <h5>
                                 
                                  
                                </h5>
                              </li> */}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="booking-sidebar-card d-none">
                      <div className="accordion-item border-0 mb-4">
                        <div className="accordion-header">
                          <div
                            className="accordion-button collapsed"
                            role="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordion_collapse_two"
                            aria-expanded="true"
                          >
                            <div className="booking-sidebar-head d-flex justify-content-between align-items-center">
                              <h5>
                                Coupon
                                <i className="fas fa-chevron-down" />
                              </h5>
                              <Link to="#" className="coupon-view">
                                View Coupons
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div id="accordion_collapse_two" className="accordion-collapse collapse">
                          <div className="booking-sidebar-body">
                            <form action="#">
                              <div className="d-flex align-items-center">
                                <div className="form-custom flex-fill">
                                  <input
                                    type="text"
                                    className="form-control mb-0"
                                    placeholder="Coupon code"
                                  />
                                </div>
                                <button
                                  type="button" data-bs-dismiss="modal"
                                  className="btn btn-secondary apply-coupon-btn d-flex align-items-center ms-2"
                                >
                                  Apply
                                  <i className="feather-arrow-right ms-2" />
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="total-rate-card">
                      <div className="vehicle-total-price">
                        <h5>Total</h5>
                        <span>
                          {CurrencySymbol}
                          &nbsp;
                          {
                            number_format(
                              Number(formData.rentDepotit)
                              +
                              Number(formData.pickCharge)
                              +
                              Number(calculatePackageAmount(
                                selectedPackageData,
                                calculateHourDifference(
                                  formData.pickUpDate,
                                  formData.pickUpTime,
                                  formData.dropOffDate,
                                  formData.dropOffTime
                                ),
                                false,
                              ))
                              ,
                              0,
                              '',
                              ',',
                            )
                          }
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingCheckout;
